import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-322548d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel-block",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "table is-fullwidth" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "sizeby" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))
const _hoisted_6 = { class: "sizeby" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1))
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('networkmsg')
          }, _toDisplayString(_ctx.t("networksize")), 9, _hoisted_3),
          _createElementVNode("td", null, _toDisplayString(_ctx.networkSize), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.t("sizebygender")) + " ", 1),
            _createElementVNode("em", null, _toDisplayString(_ctx.t("female")), 1),
            _createElementVNode("em", null, _toDisplayString(_ctx.t("male")), 1),
            _createElementVNode("em", null, _toDisplayString(_ctx.t("diverse")), 1),
            _createElementVNode("em", null, _toDisplayString(_ctx.t("notspecified")), 1)
          ]),
          _createElementVNode("td", null, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizeByGender, (gSize, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: 'g' + i
              }, _toDisplayString(gSize), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.t("sizebyhorizon")) + " ", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HORIZON_KEYS, (ho, i) => {
              return (_openBlock(), _createElementBlock("em", {
                key: 'hl' + i
              }, _toDisplayString(_ctx.t(ho)), 1))
            }), 128))
          ]),
          _createElementVNode("td", null, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizeByHorizon, (hSz, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: 'h' + i
              }, _toDisplayString(hSz), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('closenessmsg')
          }, _toDisplayString(_ctx.t("closeness")), 9, _hoisted_8),
          _createElementVNode("td", null, _toDisplayString(_ctx.naehen), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('densitymsg')
          }, _toDisplayString(_ctx.t("totaldensity")), 9, _hoisted_9),
          _createElementVNode("td", null, _toDisplayString(_ctx.density.toFixed(3)), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('degreemsg')
          }, _toDisplayString(_ctx.t("degree")), 9, _hoisted_10),
          _createElementVNode("td", null, _toDisplayString(_ctx.degree), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('starsmsg')
          }, _toDisplayString(_ctx.t("stars")), 9, _hoisted_11),
          _createElementVNode("td", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickCell('stars'))),
            class: _normalizeClass({ clickAble: _ctx.stars != '-' })
          }, _toDisplayString(_ctx.stars), 3)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('isolatedmsg')
          }, _toDisplayString(_ctx.t("isolatedpersons")), 9, _hoisted_12),
          _createElementVNode("td", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickCell('isolated'))),
            class: _normalizeClass({ clickAble: _ctx.isolated != '0' })
          }, _toDisplayString(_ctx.isolated), 3)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            title: _ctx.t('noedgemsg')
          }, _toDisplayString(_ctx.t("personswithoutedgetotheego")), 9, _hoisted_13),
          _createElementVNode("td", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickCell('alterZeroEdge'))),
            class: _normalizeClass({ clickAble: _ctx.alterZeroEdge != '0' })
          }, _toDisplayString(_ctx.alterZeroEdge), 3)
        ])
      ])
    ])
  ]))
}